import { createSlice } from "@reduxjs/toolkit";
import { generateReportThunk, resolveAddressThunk } from "./reportsActions";
import moment from "moment";

export interface IReportsFilterData {
  startDate?: string;
  endDate?: string;
  object?: string[];
  objectType?: string[];
  group?: string[];
  key?: string[];
  daysOfWeek?: number[];
  startTime?: string;
  endTime?: string;
  reportType?: number;
  rideModes?: number[];
  startedWithoutIgnition?: boolean;
}

export interface IReportsDateValues {
  startDate: Date;
  endDate: Date;
}

export interface IReportsDateValues {
  startDate: Date;
  endDate: Date;
}

export interface IReportsDateValues {
  startDate: Date;
  endDate: Date;
}

export interface IReportsFilterData {
  startDate?: string;
  endDate?: string;
  object?: string[];
  objectType?: string[];
  group?: string[];
  key?: string[];
  daysOfWeek?: number[];
  startTime?: string;
  endTime?: string;
  reportType?: number;
  rideModes?: number[];
  startedWithoutIgnition?: boolean;
  [key: string]: any;
}

export interface IReportsDateValues {
  startDate: Date;
  endDate: Date;
}

export interface IReportsState {
  loading: boolean;
  resolvedAddressLoading: boolean;
  report: Array<any>;
  resolvedAddresses: Array<any>;
  reportsFilterData: IReportsFilterData;
  hasExceededLimit: boolean | null;
  reportsDateValues: IReportsDateValues;
}

const initialState: IReportsState = {
  loading: false,
  resolvedAddressLoading: false,
  report: [],
  resolvedAddresses: [],
  reportsFilterData: {},
  reportsDateValues: {
    startDate: new Date(),
    endDate: new Date()
  },
  hasExceededLimit: null
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    resetReports: (state) => {
      state.report = [];
      state.loading = false;
      state.hasExceededLimit = null;
    },
    setReportsFilterData: (state, action) => {
      state.reportsFilterData = action.payload;
    },
    setReportsDateValues: (state, action) => {
      state.reportsDateValues = {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      };
    }
  },
  extraReducers: (builder) => {
    // Get Reports Action Cases
    builder.addCase(generateReportThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(generateReportThunk.fulfilled, (state, action: any) => {
      state.report = action.payload.data;
      state.hasExceededLimit = action.payload.hasExceededLimit;
      state.loading = false;
    });
    builder.addCase(generateReportThunk.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(resolveAddressThunk.pending, (state) => {
      state.resolvedAddressLoading = true;
    });
    builder.addCase(resolveAddressThunk.fulfilled, (state, action: any) => {
      state.resolvedAddresses = [
        ...state.resolvedAddresses,
        {
          latitude: action.meta.arg.latitude,
          longitude: action.meta.arg.longitude,
          address: action.payload.resolvedAddress
        }
      ];
      state.resolvedAddressLoading = false;
    });
    builder.addCase(resolveAddressThunk.rejected, (state) => {
      state.resolvedAddressLoading = false;
    });
  }
});

export * from "./reportsActions";
export const { resetReports, setReportsFilterData, setReportsDateValues } =
  reportsSlice.actions;
export default reportsSlice.reducer;
